<template>
  <v-card variant="outlined" class="mb-2">
    <v-card-text class="pa-3">
      <div class="d-flex justify-space-between align-center mb-1">
        <router-link
          :to="getAccountRoute({ name: 'property', params: { id: item.id }})"
          class="text-decoration-none"
        >
          <strong class="text-primary text-body-1">{{ item.name }}</strong>
        </router-link>
      </div>

      <v-list density="compact" class="pa-0">
        <v-list-item class="px-0 py-1" style="min-height: 28px;">
          <template #prepend>
            <v-icon size="small" class="mr-2 my-0">mdi-map-marker</v-icon>
          </template>
          <div class="py-0">
            <v-list-item-title class="text-body-2">{{ getFormattedAddress(item.address) }}</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item v-if="item.type" class="px-0 py-1" style="min-height: 28px;">
          <template #prepend>
            <v-icon size="small" class="mr-2 my-0">mdi-office-building</v-icon>
          </template>
          <div class="py-0">
            <v-list-item-title class="text-body-2">
              {{ item.type }}
              <span v-if="buildingClass" class="text-medium-emphasis">
                (Class {{ buildingClass }})
              </span>
            </v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item v-if="buildingSize" class="px-0 py-1" style="min-height: 28px;">
          <template #prepend>
            <v-icon size="small" class="mr-2 my-0">mdi-ruler-square</v-icon>
          </template>
          <div class="py-0">
            <v-list-item-title class="text-body-2">{{ formattedSize }}</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item v-if="item.year_built" class="px-0 py-1" style="min-height: 28px;">
          <template #prepend>
            <v-icon size="small" class="mr-2 my-0">mdi-calendar</v-icon>
          </template>
          <div class="py-0">
            <v-list-item-title class="text-body-2">Built {{ item.year_built }}</v-list-item-title>
          </div>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';
import { IAiPropertyResult } from '@/bundles/AiAgent/types';
import { formatNumber } from '@/utils/filters';
import { Nullable } from '@/utils/types';
import { getFormattedAddress } from '@/bundles/App/helpers/address/getFormattedAddress';

export default defineComponent({
  name: 'PropertyCard',
  mixins: [AccountLayoutMixin],

  props: {
    item: {
      type: Object as PropType<IAiPropertyResult>,
      required: true,
    },
  },

  computed: {
    buildingClass (): Nullable<string> {
      return this.item.building?.class;
    },

    buildingSize (): Nullable<string> {
      return this.item.size?.building?.total;
    },

    formattedSize (): string {
      if (!this.buildingSize) return 'N/A';
      return `${formatNumber(this.buildingSize)} SF`;
    },
  },

  methods: {
    getFormattedAddress,
  }
});
</script>

<style lang="scss" scoped>
:deep(.v-list-item__prepend) {
  align-self: center !important;
}
</style>
